import { Component } from '@angular/core';
@Component({
    templateUrl: './auth-wrapper.component.html',
    standalone: false
})
export class AuthWrapperComponent {}
